import useIconColor from '../../hooks/useIconColor';

const Icon = () => {
  const { background } = useIconColor();

  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M22.771 8.05713C22.2613 6.83832 21.2417 5.52645 20.438 5.11517C21.0103 6.22305 21.4078 7.41292 21.6165 8.64252V8.66353C20.3061 5.38235 18.0781 4.06147 16.2579 1.17955C16.1619 1.03546 16.072 0.888361 15.982 0.735259C15.931 0.645199 15.892 0.567147 15.853 0.495099C15.7772 0.348322 15.7189 0.193163 15.6791 0.0327917C15.6793 0.0257687 15.6769 0.0189183 15.6726 0.0134331C15.6682 0.00794791 15.662 0.00417522 15.6551 0.00277175C15.6455 -0.000923918 15.6348 -0.000923918 15.6251 0.00277175V0.00877574C15.6251 0.0147797 15.6161 0.00877574 15.6161 0.00877574V0.00277175C12.7014 1.71391 11.7089 4.88402 11.6189 6.46607C10.4524 6.54707 9.33742 6.97809 8.41928 7.70289C8.32352 7.62148 8.22341 7.54531 8.11941 7.47474C7.85404 6.54402 7.84368 5.55896 8.08943 4.62284C7.01589 5.14322 6.06212 5.88131 5.28865 6.79029C4.82385 6.2079 4.85683 4.28062 4.88382 3.87835C4.74703 3.93239 4.61635 4.00082 4.49399 4.08248C4.08608 4.37332 3.70475 4.69982 3.35449 5.05813C2.95893 5.46256 2.59783 5.89937 2.27496 6.364C1.52784 7.42419 0.997872 8.62202 0.715636 9.88834L0.694645 9.9694C0.673654 10.0685 0.592689 10.5818 0.580694 10.6899V10.7199C0.479913 11.249 0.417775 11.7848 0.394775 12.323L0.394775 12.383C0.399466 15.2947 1.49441 18.0987 3.46344 20.2417C5.43247 22.3846 8.13248 23.7106 11.0304 23.9579C13.9284 24.2052 16.8136 23.3559 19.1166 21.5776C21.4195 19.7992 22.9728 17.2212 23.4697 14.3523C23.4907 14.2022 23.5057 14.0521 23.5237 13.902C23.7644 11.9216 23.5067 9.9124 22.774 8.05713H22.771ZM9.37587 17.1622C9.42984 17.1922 9.48082 17.2222 9.5348 17.2432L9.54379 17.2492C9.48982 17.2212 9.43484 17.1912 9.37886 17.1592L9.37587 17.1622ZM21.6195 8.66053V8.65152V8.66353V8.66053Z'
        fill='url(#paint0_linear_254_560)'
      />
      <path
        d='M22.771 8.05719C22.2613 6.83838 21.2417 5.52651 20.438 5.11523C21.0103 6.22312 21.4078 7.41298 21.6165 8.64258V8.6666C22.5131 11.2328 22.3841 14.0466 21.2567 16.5198C19.9253 19.3807 16.6987 22.3137 11.6519 22.1696C6.20025 22.0195 1.39634 17.9668 0.496731 12.6593C0.334801 11.8187 0.496731 11.3984 0.580694 10.717C0.469069 11.2444 0.406826 11.781 0.394775 12.32L0.394775 12.3801C0.399466 15.2917 1.49441 18.0958 3.46344 20.2387C5.43247 22.3816 8.13248 23.7077 11.0304 23.955C13.9284 24.2023 16.8136 23.353 19.1166 21.5746C21.4195 19.7963 22.9728 17.2182 23.4697 14.3494C23.4907 14.1993 23.5057 14.0492 23.5237 13.8991C23.7644 11.9187 23.5067 9.90946 22.774 8.05419L22.771 8.05719Z'
        fill='url(#paint1_radial_254_560)'
      />
      <path
        d='M22.771 8.05719C22.2613 6.83838 21.2417 5.52651 20.438 5.11523C21.0103 6.22312 21.4078 7.41298 21.6165 8.64258V8.6666C22.5131 11.2328 22.3841 14.0466 21.2567 16.5198C19.9253 19.3807 16.6987 22.3137 11.6519 22.1696C6.20025 22.0195 1.39634 17.9668 0.496731 12.6593C0.334801 11.8187 0.496731 11.3984 0.580694 10.717C0.469069 11.2444 0.406826 11.781 0.394775 12.32L0.394775 12.3801C0.399466 15.2917 1.49441 18.0958 3.46344 20.2387C5.43247 22.3816 8.13248 23.7077 11.0304 23.955C13.9284 24.2023 16.8136 23.353 19.1166 21.5746C21.4195 19.7963 22.9728 17.2182 23.4697 14.3494C23.4907 14.1993 23.5057 14.0492 23.5237 13.8991C23.7644 11.9187 23.5067 9.90946 22.774 8.05419L22.771 8.05719Z'
        fill='url(#paint2_radial_254_560)'
      />
      <path
        d='M17.1216 9.42295C17.1515 9.44096 17.1695 9.45897 17.1935 9.47698C16.9017 8.95822 16.5383 8.48323 16.114 8.06605C12.5036 4.45164 15.1694 0.224833 15.6192 0.0116915V0.00268555C12.7045 1.71382 11.7119 4.88393 11.6219 6.46598C11.7569 6.45698 11.8918 6.44797 12.0298 6.44797C13.065 6.44946 14.0813 6.72521 14.9756 7.24719C15.8699 7.76918 16.6103 8.51881 17.1216 9.41995V9.42295Z'
        fill='url(#paint3_radial_254_560)'
      />
      <path
        d='M12.0386 10.1495C12.0177 10.4347 10.9981 11.4343 10.6383 11.4343C7.33369 11.4343 6.79993 13.4337 6.79993 13.4337C6.94386 15.1208 8.11935 16.5077 9.53474 17.2462L9.73265 17.3363C9.8466 17.3863 9.96055 17.4333 10.0745 17.4774C10.5608 17.6504 11.0702 17.7496 11.5858 17.7716C17.3793 18.0417 18.5008 10.8369 14.3207 8.74455C15.3067 8.61744 16.3048 8.86135 17.1214 9.42901C16.6102 8.52787 15.8698 7.77824 14.9755 7.25625C14.0812 6.73427 13.0649 6.45852 12.0297 6.45703C11.8917 6.45703 11.7598 6.46304 11.6218 6.47204C10.4554 6.55305 9.34036 6.98406 8.42222 7.70886C8.60214 7.85896 8.80006 8.0571 9.22287 8.47437C10.0115 9.25489 12.0326 10.0564 12.0416 10.1555L12.0386 10.1495Z'
        fill='url(#paint4_radial_254_560)'
      />
      <path
        d='M12.0386 10.1495C12.0177 10.4347 10.9981 11.4343 10.6383 11.4343C7.33369 11.4343 6.79993 13.4337 6.79993 13.4337C6.94386 15.1208 8.11935 16.5077 9.53474 17.2462L9.73265 17.3363C9.8466 17.3863 9.96055 17.4333 10.0745 17.4774C10.5608 17.6504 11.0702 17.7496 11.5858 17.7716C17.3793 18.0417 18.5008 10.8369 14.3207 8.74455C15.3067 8.61744 16.3048 8.86135 17.1214 9.42901C16.6102 8.52787 15.8698 7.77824 14.9755 7.25625C14.0812 6.73427 13.0649 6.45852 12.0297 6.45703C11.8917 6.45703 11.7598 6.46304 11.6218 6.47204C10.4554 6.55305 9.34036 6.98406 8.42222 7.70886C8.60214 7.85896 8.80006 8.0571 9.22287 8.47437C10.0115 9.25489 12.0326 10.0564 12.0416 10.1555L12.0386 10.1495Z'
        fill='url(#paint5_radial_254_560)'
      />
      <path
        d='M7.88262 7.31559C7.97258 7.37563 8.05355 7.42667 8.12252 7.4747C7.85714 6.54397 7.84678 5.55891 8.09253 4.6228C7.01899 5.14318 6.06522 5.88127 5.29175 6.79024C5.35172 6.79024 7.03099 6.76022 7.88262 7.31259V7.31559Z'
        fill='url(#paint6_radial_254_560)'
      />
      <path
        d='M0.499754 12.6594C1.39936 17.9639 6.19727 22.0166 11.6549 22.1697C16.7017 22.3138 19.9253 19.3778 21.2567 16.5199C22.3842 14.0467 22.5131 11.2329 21.6166 8.6667V8.65469V8.64269L21.6226 8.6637C22.0304 11.3595 20.663 13.9682 18.5219 15.7334L18.5129 15.7484C14.3447 19.1497 10.3565 17.8018 9.54682 17.2494C9.48684 17.2234 9.42987 17.1954 9.37589 17.1654C6.94695 16.0036 5.93939 13.7851 6.15529 11.8818C5.57827 11.8906 5.0111 11.7316 4.52251 11.4241C4.03391 11.1167 3.64486 10.674 3.40249 10.1497C4.0409 9.7583 4.76879 9.5371 5.51681 9.50715C6.26482 9.47719 7.00803 9.63949 7.67563 9.97857C9.05103 10.6029 10.6157 10.6643 12.0357 10.1497C12.0297 10.0536 10.0086 9.24909 9.21696 8.46857C8.79714 8.05429 8.59923 7.85616 8.41931 7.70606C8.32354 7.62465 8.22344 7.54848 8.11944 7.47791C8.05047 7.42988 7.9755 7.37885 7.87954 7.31881C7.03391 6.76644 5.34864 6.79646 5.29167 6.79646H5.28567C4.82687 6.21407 4.85686 4.28679 4.88385 3.88452C4.74705 3.93857 4.61638 4.00699 4.49402 4.08866C4.08598 4.38044 3.70464 4.70795 3.35451 5.06731C2.95598 5.47042 2.59186 5.90623 2.26599 6.37017C1.51887 7.43036 0.9889 8.62819 0.706664 9.89452C0.700667 9.91853 0.286847 11.7257 0.490758 12.6624L0.499754 12.6594Z'
        fill='url(#paint7_radial_254_560)'
      />
      <path
        d='M16.1169 8.06614C16.5412 8.48332 16.9047 8.95831 17.1965 9.47707C17.2565 9.52811 17.3164 9.57614 17.3704 9.62117C20.0093 12.0528 18.6299 15.4901 18.5249 15.7362C20.663 13.9711 22.0334 11.3623 21.6226 8.66654C20.3031 5.38535 18.0781 4.06447 16.2549 1.18256C16.1649 1.03846 16.075 0.891363 15.985 0.738261C15.934 0.648201 15.895 0.570149 15.8561 0.498101C15.779 0.350507 15.7196 0.194323 15.6791 0.0327917C15.6793 0.0257687 15.677 0.0189183 15.6726 0.0134331C15.6682 0.00794791 15.662 0.00417522 15.6551 0.00277175C15.6455 -0.000923918 15.6348 -0.000923918 15.6252 0.00277175V0.00877575C15.6252 0.0147797 15.6162 0.00877575 15.6162 0.00877575C15.1664 0.22492 12.4975 4.45173 16.1139 8.06614H16.1169Z'
        fill='url(#paint8_radial_254_560)'
      />
      <path
        d='M17.3674 9.6213C17.3165 9.57326 17.2565 9.52523 17.1935 9.4772L17.1215 9.42316C16.3037 8.85583 15.3044 8.61296 14.3178 8.74171C18.4979 10.8371 17.3764 18.0479 11.583 17.7717C11.0685 17.7504 10.5601 17.6523 10.0746 17.4805C9.96066 17.4405 9.84671 17.3945 9.73276 17.3424C9.66679 17.3124 9.60381 17.2824 9.53784 17.2524H9.54684C10.3565 17.8047 14.3447 19.1556 18.5189 15.7514L18.5249 15.7394C18.6299 15.4992 20.0093 12.0559 17.3734 9.6273L17.3674 9.6213Z'
        fill='url(#paint9_radial_254_560)'
      />
      <path
        d='M6.79706 13.4337C6.79706 13.4337 7.33682 11.4344 10.6354 11.4344C10.9952 11.4344 12.0148 10.4347 12.0388 10.1435C10.6174 10.6608 9.0502 10.6004 7.67268 9.97542C7.00508 9.63634 6.26186 9.47404 5.51385 9.504C4.76584 9.53395 4.03795 9.75516 3.39954 10.1465C3.64276 10.6712 4.03293 11.1139 4.52267 11.4209C5.0124 11.7278 5.58062 11.8858 6.15833 11.8757C5.93943 13.779 6.94399 15.9974 9.37594 17.1592C9.42991 17.1892 9.48089 17.2132 9.53487 17.2403C8.11648 16.5048 6.94399 15.1178 6.79706 13.4277V13.4337Z'
        fill='url(#paint10_radial_254_560)'
      />
      <path
        d='M22.7711 8.05713C22.2613 6.83832 21.2417 5.52645 20.4381 5.11517C21.0103 6.22305 21.4078 7.41292 21.6166 8.64252V8.66353C20.3061 5.38235 18.0781 4.06147 16.2579 1.17955C16.1619 1.03546 16.072 0.888361 15.982 0.735259C15.931 0.645199 15.892 0.567147 15.8531 0.495099C15.7773 0.348322 15.7189 0.193163 15.6791 0.0327917C15.6793 0.0257687 15.677 0.0189183 15.6726 0.0134331C15.6682 0.00794791 15.662 0.00417522 15.6551 0.00277175C15.6455 -0.000923918 15.6348 -0.000923918 15.6252 0.00277175V0.00877574C15.6252 0.0147797 15.6162 0.00877574 15.6162 0.00877574V0.00277175C12.7014 1.71391 11.7089 4.88402 11.6189 6.46607C11.7538 6.45706 11.8888 6.44806 12.0267 6.44806C13.0619 6.44955 14.0783 6.72529 14.9726 7.24728C15.8669 7.76926 16.6073 8.5189 17.1185 9.42003C16.301 8.85448 15.303 8.61273 14.3177 8.74158C18.4979 10.837 17.3764 18.0478 11.5829 17.7716C11.0674 17.7506 10.558 17.6525 10.0716 17.4804C9.95763 17.4404 9.84368 17.3943 9.72973 17.3423L9.53181 17.2522H9.54081C9.48683 17.2262 9.43186 17.1982 9.37588 17.1682C9.42986 17.1982 9.48084 17.2282 9.53481 17.2492C8.11643 16.5138 6.94394 15.1268 6.797 13.4367C6.797 13.4367 7.33677 11.4404 10.6353 11.4404C10.9952 11.4404 12.0147 10.4407 12.0387 10.1495C12.0327 10.0595 10.0116 9.24892 9.21995 8.47441C8.80013 8.05413 8.59922 7.859 8.4223 7.7089C8.32653 7.62748 8.22643 7.55132 8.12243 7.48074C7.85705 6.55002 7.84669 5.56496 8.09244 4.62885C7.0189 5.14923 6.06514 5.88732 5.29166 6.79629C4.82686 6.2139 4.85985 4.28662 4.88684 3.88435C4.75004 3.9384 4.61937 4.00683 4.49701 4.08849C4.08909 4.37932 3.70776 4.70582 3.3575 5.06414C2.96195 5.46856 2.60085 5.90537 2.27797 6.37001C1.53086 7.4302 1.00089 8.62802 0.71865 9.89435L0.694661 9.9694C0.67367 10.0685 0.574713 10.5908 0.55972 10.7019C0.470273 11.2383 0.413194 11.7797 0.388794 12.323V12.383C0.393485 15.2947 1.48843 18.0987 3.45746 20.2417C5.42649 22.3846 8.1265 23.7106 11.0244 23.9579C13.9224 24.2052 16.8076 23.3559 19.1106 21.5776C21.4135 19.7992 22.9668 17.2212 23.4637 14.3523C23.4847 14.2022 23.4997 14.0521 23.5177 13.902C23.7584 11.9216 23.5007 9.9124 22.7681 8.05713H22.7711ZM21.6166 8.65753V8.66653V8.65753Z'
        fill='url(#paint11_linear_254_560)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_254_560'
          x1='21.2432'
          y1='3.72'
          x2='1.33211'
          y2='21.6846'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.048' stopColor='#FFF44F' />
          <stop offset='0.111' stopColor='#FFE847' />
          <stop offset='0.225' stopColor='#FFC830' />
          <stop offset='0.368' stopColor='#FF980E' />
          <stop offset='0.401' stopColor='#FF8B16' />
          <stop offset='0.462' stopColor='#FF672A' />
          <stop offset='0.534' stopColor='#FF3647' />
          <stop offset='0.705' stopColor='#E31587' />
        </linearGradient>
        <radialGradient
          id='paint1_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(20.7298 2.66831) scale(24.2286 24.2552)'
        >
          <stop offset='0.129' stopColor='#FFBD4F' />
          <stop offset='0.186' stopColor='#FFAC31' />
          <stop offset='0.247' stopColor='#FF9D17' />
          <stop offset='0.283' stopColor='#FF980E' />
          <stop offset='0.403' stopColor='#FF563B' />
          <stop offset='0.467' stopColor='#FF3750' />
          <stop offset='0.71' stopColor='#F5156C' />
          <stop offset='0.782' stopColor='#EB0878' />
          <stop offset='0.86' stopColor='#E50080' />
        </radialGradient>
        <radialGradient
          id='paint2_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(11.8765 12.5845) scale(24.2286 24.2552)'
        >
          <stop offset='0.3' stopColor='#960E18' />
          <stop offset='0.351' stopColor='#B11927' stopOpacity='0.74' />
          <stop offset='0.435' stopColor='#DB293D' stopOpacity='0.343' />
          <stop offset='0.497' stopColor='#F5334B' stopOpacity='0.094' />
          <stop offset='0.53' stopColor='#FF3750' stopOpacity='0' />
        </radialGradient>
        <radialGradient
          id='paint3_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(14.7976 -2.8363) scale(17.5526 17.5719)'
        >
          <stop offset='0.132' stopColor='#FFF44F' />
          <stop offset='0.252' stopColor='#FFDC3E' />
          <stop offset='0.506' stopColor='#FF9D12' />
          <stop offset='0.526' stopColor='#FF980E' />
        </radialGradient>
        <radialGradient
          id='paint4_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(9.19648 18.9201) scale(11.5363 11.549)'
        >
          <stop offset='0.353' stopColor='#3A8EE6' />
          <stop offset='0.472' stopColor='#5C79F0' />
          <stop offset='0.669' stopColor='#9059FF' />
          <stop offset='1' stopColor='#C139E6' />
        </radialGradient>
        <radialGradient
          id='paint5_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(13.2004 10.5966) rotate(-13.606) scale(6.11684 7.1683)'
        >
          <stop offset='0.206' stopColor='#9059FF' stopOpacity='0' />
          <stop offset='0.278' stopColor='#8C4FF3' stopOpacity='0.064' />
          <stop offset='0.747' stopColor='#7716A8' stopOpacity='0.45' />
          <stop offset='0.975' stopColor='#6E008B' stopOpacity='0.6' />
        </radialGradient>
        <radialGradient
          id='paint6_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(11.5707 1.67574) scale(8.29919 8.30832)'
        >
          <stop stopColor='#FFE226' />
          <stop offset='0.121' stopColor='#FFDB27' />
          <stop offset='0.295' stopColor='#FFC82A' />
          <stop offset='0.502' stopColor='#FFA930' />
          <stop offset='0.732' stopColor='#FF7E37' />
          <stop offset='0.792' stopColor='#FF7139' />
        </radialGradient>
        <radialGradient
          id='paint7_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(18.094 -3.59375) scale(35.4089 35.4479)'
        >
          <stop offset='0.113' stopColor='#FFF44F' />
          <stop offset='0.456' stopColor='#FF980E' />
          <stop offset='0.622' stopColor='#FF5634' />
          <stop offset='0.716' stopColor='#FF3647' />
          <stop offset='0.904' stopColor='#E31587' />
        </radialGradient>
        <radialGradient
          id='paint8_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(15.1096 -1.62294) rotate(83.9826) scale(25.9803 17.0323)'
        >
          <stop stopColor='#FFF44F' />
          <stop offset='0.06' stopColor='#FFE847' />
          <stop offset='0.168' stopColor='#FFC830' />
          <stop offset='0.304' stopColor='#FF980E' />
          <stop offset='0.356' stopColor='#FF8B16' />
          <stop offset='0.455' stopColor='#FF672A' />
          <stop offset='0.57' stopColor='#FF3647' />
          <stop offset='0.737' stopColor='#E31587' />
        </radialGradient>
        <radialGradient
          id='paint9_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(11.3751 4.75326) scale(22.1064 22.1307)'
        >
          <stop offset='0.137' stopColor='#FFF44F' />
          <stop offset='0.48' stopColor='#FF980E' />
          <stop offset='0.592' stopColor='#FF5634' />
          <stop offset='0.655' stopColor='#FF3647' />
          <stop offset='0.904' stopColor='#E31587' />
        </radialGradient>
        <radialGradient
          id='paint10_radial_254_560'
          cx='0'
          cy='0'
          r='1'
          gradientUnits='userSpaceOnUse'
          gradientTransform='translate(17.2106 6.04851) scale(24.1953 24.2219)'
        >
          <stop offset='0.094' stopColor='#FFF44F' />
          <stop offset='0.231' stopColor='#FFE141' />
          <stop offset='0.509' stopColor='#FFAF1E' />
          <stop offset='0.626' stopColor='#FF980E' />
        </radialGradient>
        <linearGradient
          id='paint11_linear_254_560'
          x1='21.005'
          y1='3.624'
          x2='4.04177'
          y2='19.4772'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0.167' stopColor='#FFF44F' stopOpacity='0.8' />
          <stop offset='0.266' stopColor='#FFF44F' stopOpacity='0.634' />
          <stop offset='0.489' stopColor='#FFF44F' stopOpacity='0.217' />
          <stop offset='0.6' stopColor='#FFF44F' stopOpacity='0' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default Icon;
